module.exports = __webpack_public_path__ + "GPO-LF-granulates.jpg?d3d267bf65340a8ea4e4caf4cd31d342";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/GPO-LF-granulates.jpg
// module id = 87
// module chunks = 0